import Backbone from 'backbone';
import AnalyticAppDisplayRule from 'common/constants/analytic-app-display-rule';
import {ReportingPeriodEnum} from 'common/proxies/enum-proxy';
import {t} from 'common/utils/translation-util';

Backbone.$ = $;

const OdometerLabelView = Backbone.View.extend({
  getOutcome(point) {
    for (const propName in AnalyticAppDisplayRule) {
      const rules = AnalyticAppDisplayRule[propName];

      if (rules && rules.hasOwnProperty('type')) {
        const type = rules.type;
        if (type && type.slug === point.type.slug) {
          return ` ${rules.outcome.displayNamePast.toLowerCase()} `;
        }
      }
    }
    return '';
  },

  getPeriodLabel(period) {
    switch (period.slug) {
      case ReportingPeriodEnum.WEEK.slug:
        return t('this week');
      case ReportingPeriodEnum.MONTH.slug:
        return t('this month');
      case ReportingPeriodEnum.YEAR.slug:
        return t('this year');
      default:
        return period.displayName.toLowerCase();
    }
  },

  initialize(options) {
    this.systemName = options.systemName;
  },

  render(period) {
    const point = this.collection.getPoint(this.systemName);
    const {integrated} = point.units;
    const periodLabel = this.getPeriodLabel(period);
    const outcome = this.getOutcome(point);
    const label = integrated.displayName + outcome + periodLabel;
    this.$el.html(label.toLowerCase());
  },
});

export default OdometerLabelView;
